import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var GlobeSvg = function GlobeSvg(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M15 21v-4H9a22 22 0 00.52 4zM7 17H2a14 14 0 00.89 4h4.6A23 23 0 017 17zM17 17v4h5.47a22 22 0 00.53-4zM25 17a23 23 0 01-.49 4h4.6a14 14 0 00.89-4zM24 9h4.17a14 14 0 00-8.07-6.36A13.83 13.83 0 0124 9zM17 3.16V9h4.88C20.74 5.82 18.9 3.72 17 3.16zM25 15h5a14 14 0 00-.89-4h-4.6a23 23 0 01.49 4zM17 11v4h6a22 22 0 00-.52-4zM17 23v5.84c1.9-.56 3.74-2.66 4.88-5.84zM24 23a13.83 13.83 0 01-3.9 6.36A14 14 0 0028.16 23zM10.12 23c1.14 3.18 3 5.28 4.88 5.84V23zM8 23H3.84a14 14 0 008.07 6.36A13.83 13.83 0 018 23zM15 9V3.16c-1.9.56-3.74 2.66-4.88 5.84zM11.91 2.64A14 14 0 003.84 9H8a13.83 13.83 0 013.91-6.36zM15 15v-4H9.53A22 22 0 009 15zM7.49 11h-4.6A14 14 0 002 15h5a23 23 0 01.49-4z"
  }));
};
GlobeSvg.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(GlobeSvg);